module.exports = __webpack_public_path__ + "assets/213e29c17a1957e37d6d6e801e7bdac2.png";